module.exports = __webpack_public_path__ + "img/3454.0ae17f3c.jpg";